import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from "@ngx-translate/core";
import { PageTitleComponent } from "./page-title";
import {SocialShareModuleGeneric} from '@signature-it/ngx-generic/components/social-share';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        SocialShareModuleGeneric
    ],
    declarations: [PageTitleComponent],
    exports: [PageTitleComponent]
})
export class PageTitleModuleGeneric {}
